import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap5';

import { useTableContext } from './TableContext';
import Actions from './Actions';

const mapActions = (row, action) => {
  const key = `row-action-${row.id}-${Math.floor(Math.random() * 1000)}`;
  const { dispatch } = useTableContext();

  const title = action.title || action.type.toLowerCase();
  const iconClass = action.iconClass || `${title}-icon`;

  const clearSelected = () => {
    Actions.selectRow(dispatch, row, false);
  };

  switch (action.type) {
    case 'DIVIDER': {
      return <Dropdown.Divider key={key} />;
    }
    case 'EXPAND': {
      const onClick = (e) => {
        const cellElement = e.target.closest('.rdt_TableCell');
        const rowElement = cellElement.parentElement;

        if (row.expanded) {
          row.expanded = false;
          rowElement.classList.remove('expanded');
        } else {
          row.expanded = true;
          rowElement.classList.add('expanded');
        }

        cellElement.style.height = `${rowElement.clientHeight - 1}px`;
      };

      return (
        <Dropdown.Item key={key} onClick={(e) => onClick(e)}>
          <div className="icon-with-text">
            <i className={`small-icon ${iconClass}`} />
            <div className="text-content">
              {title}
            </div>
          </div>
        </Dropdown.Item>
      );
    }
    case 'CUSTOM': {
      if (action.showCondition !== undefined && !action.showCondition(row)) {
        return null;
      }

      return (
        <Dropdown.Item
          key={key}
          href={action.href ? action.href(row) : undefined}
          rel="noreferrer"
          target="_blank"
          onClick={action.onClick ? () => action.onClick(row, { clearSelected }) : undefined}
        >
          <div className="icon-with-text">
            <i className={`small-icon ${iconClass}`} />
            <div className="text-content">
              {title}
            </div>
          </div>
        </Dropdown.Item>
      );
    }
    default:
      throw Error(`Unknown row action: ${action.type}`);
  }
};

export default function RowActions({ row, actions }) {
  return (
    <div className="actions">
      <Dropdown className="position-static">
        <Dropdown.Toggle variant="" className="btn-link">
          <div className="icon-with-text">
            <i className="small-icon options-icon" />
          </div>
        </Dropdown.Toggle>

        <Dropdown.Menu align="end">
          { actions.map((action) => mapActions(row, action)) }
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}

RowActions.propTypes = {
  row: PropTypes.object.isRequired,
  actions: PropTypes.arrayOf(PropTypes.object).isRequired,
};
